// extracted by mini-css-extract-plugin
export default {"container":"CreateBookingCustomer_container__gorxA","switch":"CreateBookingCustomer_switch__iJnbD"};